import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/resources/$resourceId")({
  component: lazyRouteComponent(() => import("./+ResourcePage")),
  beforeLoad: () => ({
    breadcrumb: "Edit Resource",
  }),
  head: () => ({
    meta: seo({ title: "Edit Resource" }),
  }),
});
